var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNl = function SvgNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "nl_svg__a",
    cx: 16.5,
    cy: 16.5,
    r: 16.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nl_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nl_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#nl_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M0 10.764 16.358 9.52 33 10.764v11.472l-16.43 2.082L0 22.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h33v10.764H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 22.236h33V33H0z"
  })))));
};
export default SvgNl;